import './modules/common';
import './modules/news-slider';
import {NewList} from "./modules/NewList";

document.addEventListener(
    "DOMContentLoaded", () => {
        if (document.querySelector('.news-section')) {
            try {
                new NewList()
            } catch (e) {
                console.log(e.message)
            }
        }
    }
)